/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum StorageTier {
    HOT = 'hot',
    COOL = 'cool',
    COLD = 'cold',
    ARCHIVE = 'archive',
}
